import React from 'react'
import { Outlet } from 'react-router-dom'
import SideBarCompany from '../SideBarCompany'
import CompanyTopbar from '../Topbar/CompanyTopbar'

const LayoutCompany = () => {
    return (
        <div className="">
            <CompanyTopbar />
            <div className='dashboard'>
                <SideBarCompany />
                <Outlet />
            </div>
        </div>
    )
}

export default LayoutCompany